import React from 'react';
import classes from './TableHeader.module.scss'

const TableHeader = ({className, children}) => {
    return (
        <div className={`${classes.Container} ${className ?? ''}`}>
            {children}
        </div>
    );
};

export default TableHeader;